(() => {
  const COUNTRY_DATA = [
    ["AF", "+93"],
    ["AX", "+358"],
    ["AL", "+355"],
    ["DZ", "+213"],
    ["AS", "+1684"],
    ["AD", "+376"],
    ["AO", "+244"],
    ["AI", "+1264"],
    ["AQ", "+672"],
    ["AG", "+1268"],
    ["AR", "+54"],
    ["AM", "+374"],
    ["AW", "+297"],
    ["AU", "+61"],
    ["AT", "+43"],
    ["AZ", "+994"],
    ["BS", "+1242"],
    ["BH", "+973"],
    ["BD", "+880"],
    ["BB", "+1246"],
    ["BY", "+375"],
    ["BE", "+32"],
    ["BZ", "+501"],
    ["BJ", "+229"],
    ["BM", "+1441"],
    ["BT", "+975"],
    ["BO", "+591"],
    ["BA", "+387"],
    ["BW", "+267"],
    ["BV", "+47"],
    ["BR", "+55"],
    ["IO", "+246"],
    ["VG", "+1284"],
    ["BN", "+673"],
    ["BG", "+359"],
    ["BF", "+226"],
    ["BI", "+257"],
    ["KH", "+855"],
    ["CM", "+237"],
    ["CA", "+1"],
    ["CV", "+238"],
    ["BQ", "+599"],
    ["KY", "+1345"],
    ["CF", "+236"],
    ["TD", "+235"],
    ["CL", "+56"],
    ["CN", "+86"],
    ["CX", "+61"],
    ["CC", "+61"],
    ["CO", "+57"],
    ["KM", "+269"],
    ["CD", "+243"],
    ["CG", "+242"],
    ["CK", "+682"],
    ["CR", "+506"],
    ["CI", "+225"],
    ["HR", "+385"],
    ["CU", "+53"],
    ["CW", "+599"],
    ["CY", "+357"],
    ["CZ", "+420"],
    ["DK", "+45"],
    ["DJ", "+253"],
    ["DM", "+1767"],
    ["DO", "+1"],
    ["EC", "+593"],
    ["EG", "+20"],
    ["SV", "+503"],
    ["GQ", "+240"],
    ["ER", "+291"],
    ["EE", "+372"],
    ["ET", "+251"],
    ["FK", "+500"],
    ["FO", "+298"],
    ["FJ", "+679"],
    ["FI", "+358"],
    ["FR", "+33"],
    ["GF", "+594"],
    ["PF", "+689"],
    ["TF", "+262"],
    ["GA", "+241"],
    ["GM", "+220"],
    ["GE", "+995"],
    ["DE", "+49"],
    ["GH", "+233"],
    ["GI", "+350"],
    ["GR", "+30"],
    ["GL", "+299"],
    ["GD", "+1473"],
    ["GP", "+590"],
    ["GU", "+1671"],
    ["GT", "+502"],
    ["GG", "+44"],
    ["GN", "+224"],
    ["GW", "+245"],
    ["GY", "+592"],
    ["HT", "+509"],
    ["HM", "+672"],
    ["HN", "+504"],
    ["HK", "+852"],
    ["HU", "+36"],
    ["IS", "+354"],
    ["IN", "+91"],
    ["ID", "+62"],
    ["IR", "+98"],
    ["IQ", "+964"],
    ["IE", "+353"],
    ["IM", "+44"],
    ["IL", "+972"],
    ["IT", "+39"],
    ["JM", "+1876"],
    ["JP", "+81"],
    ["JE", "+44"],
    ["JO", "+962"],
    ["KZ", "+7"],
    ["KE", "+254"],
    ["KI", "+686"],
    ["XK", "+383"],
    ["KW", "+965"],
    ["KG", "+996"],
    ["LA", "+856"],
    ["LV", "+371"],
    ["LB", "+961"],
    ["LS", "+266"],
    ["LR", "+231"],
    ["LY", "+218"],
    ["LI", "+423"],
    ["LT", "+370"],
    ["LU", "+352"],
    ["MO", "+853"],
    ["MK", "+389"],
    ["MG", "+261"],
    ["MW", "+265"],
    ["MY", "+60"],
    ["MV", "+960"],
    ["ML", "+223"],
    ["MT", "+356"],
    ["MH", "+692"],
    ["MQ", "+596"],
    ["MR", "+222"],
    ["MU", "+230"],
    ["YT", "+262"],
    ["MX", "+52"],
    ["FM", "+691"],
    ["MD", "+373"],
    ["MC", "+377"],
    ["MN", "+976"],
    ["ME", "+382"],
    ["MS", "+1664"],
    ["MA", "+212"],
    ["MZ", "+258"],
    ["MM", "+95"],
    ["NA", "+264"],
    ["NR", "+674"],
    ["NP", "+977"],
    ["NL", "+31"],
    ["NC", "+687"],
    ["NZ", "+64"],
    ["NI", "+505"],
    ["NE", "+227"],
    ["NG", "+234"],
    ["NU", "+683"],
    ["NF", "+672"],
    ["KP", "+850"],
    ["MP", "+1670"],
    ["NO", "+47"],
    ["OM", "+968"],
    ["PK", "+92"],
    ["PW", "+680"],
    ["PS", "+970"],
    ["PA", "+507"],
    ["PG", "+675"],
    ["PY", "+595"],
    ["PE", "+51"],
    ["PH", "+63"],
    ["PN", "+64"],
    ["PL", "+48"],
    ["PT", "+351"],
    ["PR", "+1"],
    ["QA", "+974"],
    ["RE", "+262"],
    ["RO", "+40"],
    ["RU", "+7"],
    ["RW", "+250"],
    ["BL", "+590"],
    ["SH", "+290"],
    ["KN", "+1869"],
    ["LC", "+1758"],
    ["MF", "+590"],
    ["PM", "+508"],
    ["VC", "+1784"],
    ["WS", "+685"],
    ["SM", "+378"],
    ["ST", "+239"],
    ["SA", "+966"],
    ["SN", "+221"],
    ["RS", "+381"],
    ["SC", "+248"],
    ["SL", "+232"],
    ["SG", "+65"],
    ["SX", "+1721"],
    ["SK", "+421"],
    ["SI", "+386"],
    ["SB", "+677"],
    ["SO", "+252"],
    ["ZA", "+27"],
    ["GS", "+500"],
    ["KR", "+82"],
    ["SS", "+211"],
    ["ES", "+34"],
    ["LK", "+94"],
    ["SD", "+249"],
    ["SR", "+597"],
    ["SJ", "+47"],
    ["SZ", "+268"],
    ["SE", "+46"],
    ["CH", "+41"],
    ["SY", "+963"],
    ["TW", "+886"],
    ["TJ", "+992"],
    ["TZ", "+255"],
    ["TH", "+66"],
    ["TL", "+670"],
    ["TG", "+228"],
    ["TK", "+690"],
    ["TO", "+676"],
    ["TT", "+1868"],
    ["TN", "+216"],
    ["TR", "+90"],
    ["TM", "+993"],
    ["TC", "+1649"],
    ["TV", "+688"],
    ["VI", "+1340"],
    ["UG", "+256"],
    ["UA", "+380"],
    ["AE", "+971"],
    ["GB", "+44"],
    ["US", "+1"],
    ["UM", "+1"],
    ["UY", "+598"],
    ["UZ", "+998"],
    ["VU", "+678"],
    ["VA", "+39"],
    ["VE", "+58"],
    ["VN", "+84"],
    ["WF", "+681"],
    ["EH", "+212"],
    ["YE", "+967"],
    ["ZM", "+260"],
    ["ZW", "+263"],
  ];

  const regionNames =
    typeof Intl !== "undefined" && Intl.DisplayNames
      ? new Intl.DisplayNames(["en"], { type: "region" })
      : null;

  const normalize = (value) =>
    value
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

  const getCountryName = (iso) => {
    if (!regionNames) return iso;

    try {
      return regionNames.of(iso) || iso;
    } catch (error) {
      return iso;
    }
  };

  const FLAG_OVERRIDES = {
    BV: "NO",
    TF: "FR",
    HM: "AU",
    PN: "GB",
    GS: "GB",
    UM: "US",
  };

  const getFlagIso = (iso) => FLAG_OVERRIDES[iso] || iso;

  class WarrantyCountrySelect extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        document.addEventListener("click", this.boundOutsideClick);
        document.addEventListener("keydown", this.boundKeydown);
        return;
      }

      this.initialized = true;
      this.trigger = this.querySelector(".register-warranty__country-trigger");
      this.flagElement = this.querySelector(
        ".register-warranty__selected-flag",
      );
      this.dropdown = this.querySelector(
        ".register-warranty__country-dropdown",
      );
      this.searchInput = this.querySelector(
        ".register-warranty__country-search-input",
      );
      this.list = this.querySelector(".register-warranty__country-list");
      this.empty = this.querySelector(".register-warranty__country-empty");
      this.isoInput = this.querySelector(
        ".register-warranty__country-iso-input",
      );
      this.nameInput = this.querySelector(
        ".register-warranty__country-name-input",
      );
      this.dialInput = this.querySelector(
        ".register-warranty__country-dial-input",
      );

      if (!this.trigger || !this.dropdown || !this.searchInput || !this.list)
        return;

      this.countries = COUNTRY_DATA.map(([iso, dial]) => {
        const name = getCountryName(iso);
        return {
          iso,
          dial,
          name,
          flagIso: getFlagIso(iso),
          search: normalize(`${name} ${iso} ${dial}`),
        };
      });

      this.boundOutsideClick = this.onOutsideClick.bind(this);
      this.boundKeydown = this.onKeydown.bind(this);

      this.renderOptions();
      this.selectCountry(this.dataset.defaultCountry || "AL");
      this.bindEvents();
    }

    disconnectedCallback() {
      document.removeEventListener("click", this.boundOutsideClick);
      document.removeEventListener("keydown", this.boundKeydown);
    }

    bindEvents() {
      this.trigger.addEventListener("click", () => this.toggle());
      this.searchInput.addEventListener("input", () => this.filterOptions());
      this.list.addEventListener("click", (event) => this.onOptionClick(event));
      document.addEventListener("click", this.boundOutsideClick);
      document.addEventListener("keydown", this.boundKeydown);
    }

    renderOptions() {
      const fragment = document.createDocumentFragment();

      this.countries.forEach((country) => {
        const item = document.createElement("li");
        const button = document.createElement("button");
        const flag = document.createElement("span");
        const name = document.createElement("span");
        const dial = document.createElement("span");

        button.type = "button";
        button.className = "register-warranty__country-option";
        button.dataset.countryOption = "";
        button.dataset.iso = country.iso;
        button.dataset.search = country.search;
        button.setAttribute("role", "option");
        button.setAttribute("aria-selected", "false");

        flag.className = `register-warranty__country-option-flag register-warranty__flag register-warranty__flag--${country.flagIso.toLowerCase()}`;
        flag.setAttribute("aria-hidden", "true");

        name.className = "register-warranty__country-option-name";
        name.textContent = country.name;

        dial.className = "register-warranty__country-option-dial";
        dial.textContent = country.dial;

        button.append(flag, name, dial);
        item.append(button);
        fragment.append(item);
      });

      this.list.append(fragment);
      this.optionButtons = Array.from(
        this.list.querySelectorAll("[data-country-option]"),
      );
    }

    onOptionClick(event) {
      const option = event.target.closest("[data-country-option]");
      if (!option) return;

      this.selectCountry(option.dataset.iso);
      this.close();
      this.closest(".register-warranty__phone-field")
        ?.querySelector(".register-warranty__phone-input")
        ?.focus();
    }

    selectCountry(iso) {
      const nextIso = iso.toUpperCase();
      const country =
        this.countries.find((item) => item.iso === nextIso) ||
        this.countries.find((item) => item.iso === "AL") ||
        this.countries[0];

      if (!country) return;

      this.selectedCountry = country;
      this.flagElement.className = `register-warranty__selected-flag register-warranty__flag register-warranty__flag--${country.flagIso.toLowerCase()}`;
      this.isoInput.value = country.iso;
      this.nameInput.value = country.name;
      this.dialInput.value = country.dial;

      this.optionButtons?.forEach((button) => {
        button.setAttribute(
          "aria-selected",
          String(button.dataset.iso === country.iso),
        );
      });
    }

    filterOptions() {
      const query = normalize(this.searchInput.value.trim());
      let visibleCount = 0;

      this.optionButtons.forEach((option) => {
        const isVisible = option.dataset.search.includes(query);
        option.parentElement.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      if (this.empty) this.empty.hidden = visibleCount > 0;
    }

    toggle() {
      this.isOpen() ? this.close() : this.open();
    }

    open() {
      this.dropdown.hidden = false;
      this.trigger.setAttribute("aria-expanded", "true");
      this.searchInput.focus();
    }

    close() {
      this.dropdown.hidden = true;
      this.trigger.setAttribute("aria-expanded", "false");
      this.searchInput.value = "";
      this.filterOptions();
    }

    isOpen() {
      return !this.dropdown.hidden;
    }

    onOutsideClick(event) {
      if (!this.isOpen() || this.contains(event.target)) return;
      this.close();
    }

    onKeydown(event) {
      if (!this.isOpen() || event.key !== "Escape") return;
      this.close();
      this.trigger.focus();
    }
  }

  if (!customElements.get("warranty-country-select")) {
    customElements.define("warranty-country-select", WarrantyCountrySelect);
  }
})();
